import { CSSProperties, FC, ReactElement, ReactNode, useState } from 'react';

import { Box, Paper } from '@mui/material';
import { clsx } from 'clsx';
import { useBreakpoints } from 'hooks';

import { Responsive } from 'components/_basic/Responsive';

import { FullscreenButton, FullscreenButtonMobile } from './components/FullscreenButton';

import styles from './OnePagePreviewLayout.module.scss';

import scssVariables from 'styles/sass-variables.module.scss';

export interface IOnePagePreviewLayoutProps {
  header: ReactElement;
  modeSwitch?: ReactNode;
  onePagePreviewControls?: ReactElement;
  onePagePreviewControlsMobile?: ReactElement;
  onePagePreview: ReactElement;
}

const getRootCss = (isMobile: boolean) => {
  return {
    '--mui-toolbar-height': !isMobile ? scssVariables.headerHeight : scssVariables.headerHeightMobile,
  } as CSSProperties;
};

export const OnePagePreviewLayout: FC<IOnePagePreviewLayoutProps> = ({
  header,
  onePagePreview,
  modeSwitch,
  onePagePreviewControls,
  onePagePreviewControlsMobile,
}) => {
  const [isFullscreen, setFullscreen] = useState(false);
  const { isMobile } = useBreakpoints();

  return (
    <>
      <div style={getRootCss(isMobile)} className={clsx(styles['root'], isFullscreen && styles['fullscreen'])}>
        {!isFullscreen && (
          <div className={styles['controls_wrapper']}>
            <div className={styles['header']}>{header}</div>
            <div className={styles['controls']}>
              <div className={styles['mode_switch']}>{modeSwitch}</div>
              <Responsive aboveMobile>
                <Box className={styles['preview-controls']}>{onePagePreviewControls}</Box>
              </Responsive>
            </div>
          </div>
        )}
        <Box className={styles['content']}>{onePagePreview}</Box>
      </div>
      <Box className={styles['fixed-controls-wrapper']}>
        <Responsive aboveMobile>
          <FullscreenButton toggleFullscreen={() => setFullscreen((v) => !v)} isFullscreen={isFullscreen} />
        </Responsive>
        <Responsive mobile>
          {isFullscreen ? (
            <FullscreenButton toggleFullscreen={() => setFullscreen(false)} isFullscreen={isFullscreen} />
          ) : (
            <Paper elevation={3} className={styles['mobile-controls']}>
              {onePagePreviewControlsMobile}
              <FullscreenButtonMobile onClick={() => setFullscreen(true)} />
            </Paper>
          )}
        </Responsive>
      </Box>
    </>
  );
};
